import { useState } from 'react';
import { api } from '@/lib/api';

interface LoginModalProps {
  isOpen: boolean;
  onLoginSuccess: () => void;
}

export function LoginModal({ isOpen, onLoginSuccess }: LoginModalProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      const data = await api.login(password);

      // Store token
      localStorage.setItem('auth_token', data.token);
      // Trigger success callback - parent component will handle re-render
      onLoginSuccess();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <form onSubmit={handleSubmit} className="bg-bg-primary rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <h2 className="text-xl font-bold mb-4">Login</h2>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter password"
          className="w-full px-3 py-2 bg-bg-secondary rounded border border-border mb-4 focus:outline-none focus:border-accent"
          autoFocus
        />
        {error && <div className="text-red-500 mb-4">{error}</div>}
        <div className="flex gap-2">
          <button
            type="submit"
            disabled={isLoading || !password}
            className="flex-1 px-4 py-2 bg-accent text-white rounded hover:bg-accent/90 disabled:opacity-50 disabled:cursor-not-allowed transition"
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </div>
      </form>
    </div>
  );
}
